export { default as EpgModal } from "./epg-modal";
export { default } from "./epg-modal";
